import { render } from "./UserIdentityCard.vue?vue&type=template&id=8050a07e&scoped=true"
import script from "./UserIdentityCard.vue?vue&type=script&lang=js"
export * from "./UserIdentityCard.vue?vue&type=script&lang=js"

import "./UserIdentityCard.vue?vue&type=style&index=0&id=8050a07e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8050a07e"]])

export default __exports__